import useApp from "./useApp";

const useIsSendInputDisabled = () => {
    const  { mode, defaultInputOn, ended, connectedToAgent } = useApp();
    if (ended) return true;
    if (mode === "DISABLED" as any) {
        return true;
    }
    if (mode === "SECURE" || mode === "TEXT") return false;
    if (connectedToAgent) return false;
    return !defaultInputOn;
}

export default useIsSendInputDisabled;

